module.exports = __webpack_public_path__ + "img/mb-step-4.02e951eb.png";